import { MODAL_SET_DATA } from "./types";
import { Login } from "~/components/auth/Login";
import { Register } from "~/components/auth/Register";
import { Forgot } from "~/components/auth/Forgot";

export const setModal = (data) => (dispatch) => {
    if (data) dispatch({ type: MODAL_SET_DATA, payload: data });
};

export const resetModal = () => {
    return {
        type: MODAL_SET_DATA,
        payload: {
            content: null,
            title: null,
            show: false,
            onClose: () => {},
        },
    };
};

export const openLogin = (redirect) => {
    return {
        type: MODAL_SET_DATA,
        payload: {
            content: <Login redirect={redirect} />,
            title: "Login",
            show: true,
        },
    };
};

export const openForgot = () => {
    return {
        type: MODAL_SET_DATA,
        payload: {
            content: <Forgot />,
            title: "Passwort zurücksetzen",
            show: true,
        },
    };
};

export const openRegister = () => (dispatch) => {
    dispatch({
        type: MODAL_SET_DATA,
        payload: {
            content: <Register setModal={(d) => dispatch(setModal(d))} />,
            title: "Registrieren",
            show: true,
        },
    });
};
